import { accentureLink, bcgXLink, infosysLink } from "./links";

const experienceData = [
  {
    id: 1,
    title: "Boston Consulting Group",
    timeline: "April 2022 - Present",
    link: bcgXLink,
    subtitle: "Senior Software Engineer",
    description:
      "At BCG as a Senior Software Engineer, I work at company's Gurgaon offices in India.",
    data: ["I work as a full stack developer in BCG's technology division."],
  },
  {
    id: 2,
    title: "Accenture",
    timeline: "November 2019 - March 2022",
    link: accentureLink,
    subtitle: "Software Engineer",
    description:
      "At Accenture as a Software Engineer, I worked at company's Bangalore offices in India.",
    data: [
      "Developed software as a full stack developer for the Technology for Operations (Tfo) team.",
      "In the delivery of projects created from scratch, used the agile principle and Azure DevOps tools.",
      "Awarded twice for being a high performer and an inspiring innovator within the organization.",
    ],
  },
  {
    id: 3,
    title: "Infosys",
    timeline: "January 2019 - April 2019",
    link: infosysLink,
    subtitle: "Software Engineer Intern",
    description:
      "At Infosys as an Intern, I worked within the company's best training facilities in Mysore, India.",
    data: [
      "Scored above 90% in and cleared all knowledge tests like python, web technologies etc. during internship.",
      "Had a placement offer from Infosys, created an e-commerce web app using Angular in team as minor project.",
    ],
  },
];

export default experienceData;
